<template>
  <v-row>
    <v-col cols="12" align="center">
      <v-img
        v-if="imagePreview.src"
        :src="imagePreview.src"
        :style="imageStyle"
        max-width="200"
        max-height="200"
        aspect-ratio="1"
      >
      </v-img>
      <v-img
        v-else-if="!imageURL"
        src="@/assets/images/ic_imageUpload@3x.png"
        width="159"
        height="160"
        class="ma-4"
      ></v-img>
      <v-img
        v-else
        :src="imageURL"
        :style="imageStyle"
        max-width="200"
        max-height="200"
        aspect-ratio="1"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="primary lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <input
        accept="image/*"
        type="file"
        ref="file"
        style="display: none"
        @change="selectImage"
      />
      <v-btn
        outlined
        tile
        class="text-none button ma-4"
        color="primary"
        @click="action"
        >{{ actionTitle }}</v-btn
      >
      <div class="uploadHint" v-if="showHint">
        Images must be either .jpeg or .png
      </div>
      <div class="uploadHint" v-if="showHint">
        and a minimum of 200 x 200 px
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    imageURL: {
      type: String,
    },
    imagePreview: {
      type: Object,
      default: () => ({}),
    },
    'persistent-hint': {
      type: Boolean,
      default: true,
    },
    imageStyle: {
      type: Object,
    },
  },
  computed: {
    actionTitle() {
      return this.imageURL || this.imagePreview?.src
        ? 'Remove image'
        : 'Select image'
    },
    showHint() {
      return this['persistent-hint']
    },
  },
  methods: {
    action() {
      if (this.imageURL || this.imagePreview?.src) {
        this.removeImage()
      } else {
        this.$refs.file.click()
      }
    },
    removeImage() {
      // TODO Remove image.
      if (this.imageURL) {
        this.$emit('removeImage', this.imageURL)
        this.$emit('update:imageURL', null)
      }
      if (this.imagePreview?.src) {
        this.$emit('update:imagePreview', {})
      }
    },
    selectImage(event) {
      const file = event.target.files[0]

      if (file) {
        const reader = new FileReader()

        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          const img = new Image()
          img.onload = () => {
            if (
              img.width <= 200 ||
              img.height <= 200 ||
              file.size / 1024 > 5000
            ) {
              // FIXME: [CW-72] Image selection error must be shown in app-styled notification
              alert(
                'Image size must be minimum 200x200 pixels and smaller than 5MB'
              )
            } else {
              this.$emit('update:imagePreview', {
                ...img,
                src: evt.target.result,
                file,
              })
            }
          }
          img.src = evt.target.result
        }

        reader.onerror = (evt) => {
          console.error(evt)
        }
      } else {
        this.$emit('update:imagePreview', {})
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.uploadHint
  @include body_dark
  font-size: 17px
</style>
